import { AxiosError } from 'axios';

import { TERRITORY_SETTINGS_API_URL } from '@/constants/apis';
import { configuration } from '@/constants/config';
import { apiManager } from '@/helpers/api.manager';
import { ApiResponse } from '@/types/response.type';
import { ZorTerritorySettings } from '@/types/zor.territory-settings.type';

export const getZorTerritorySettings = async (): Promise<
  ApiResponse<ZorTerritorySettings>
> => {
  try {
    const response = await apiManager.get(`${TERRITORY_SETTINGS_API_URL}`, {
      baseURL: configuration.TERRITORIES_API_URL,
      headers: { 'Content-Type': 'application/json' },
    });

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};
